import { siteImproveEventPush } from '../plugins/siteimprove';

export type DesktopNav = {
  otherSubnavIsOpen: boolean;
  navHover: boolean;
  subnavOpen?: boolean;
  sendDidClickMenuEvent(menuName: string, parent?: string): void;
};

function desktopNav(hasChildren: boolean): DesktopNav {
  const category: string = 'Desktop menu';

  return {
    navHover: false,
    ...(hasChildren && {
      subnavOpen: false,
      otherSubnavIsOpen: false,
    }),
    sendDidClickMenuEvent(menuName, parent) {
      parent !== undefined
        ? siteImproveEventPush(null, category, parent, menuName)
        : siteImproveEventPush(null, category, menuName);
    },
  };
}

window.desktopNav = desktopNav;
